import { TeamsAndPlayers } from "../../components/teamsAndPlayers";
export function TeamsAndPlayersPage() {
  return <TeamsAndPlayers />;
}
